<template>
  <div>
    <div class="infoSteps container-fluid">
      <div class="card percent">
        <div class v-bind:class="[parseInt(stepIndex) >= 3 ? 'no__progress' : '']">
          <h3
            v-if="parseInt(stepIndex) < 3"
          >{{translation.after_finish_steps}} {{25 * parseInt(stepIndex)}}{{translation.off_your_chalenge}}</h3>
          <h2 v-if="parseInt(stepIndex) == 3 || parseInt(stepIndex) == 4">{{translation.congrats_close_objective}}</h2>
          <h2 v-if="parseInt(stepIndex) == 5">{{translation.congrats_close_objective_5}}</h2>
          <h2 v-if="parseInt(stepIndex) == 6">{{translation.congrats_close_objective_6}}</h2>

          <div class="progress__bar" v-if="parseInt(stepIndex) < 3">
            <div class="row">
              <div class="col-md-10 col-sm-10 col-lg-10 col-xs-10">
                <div class="progress__container-in">
                  <div
                    class="progress__bar-in"
                    data-container="body"
                    data-toggle="popover"
                    data-placement="bottom"
                    data-trigger="hover"
                    v-bind:style="{ width: 25 * parseInt(stepIndex) + '%' }"
                  ></div>
                </div>
                <div class="progress__container-in">
                  <a class="progress__present-initial"></a>
                </div>
              </div>
              <div class="col-md-2 col-sm-2 col-lg-2 col-xs-2">
                <div class="progress__check-final">{{25 * parseInt(stepIndex)}}%</div>
              </div>
            </div>
          </div>
          <div class="next__step">
            <h3 v-if="parseInt(stepIndex) < 3">
              {{translation.finish_the_step}} {{parseInt(stepIndex)}} {{translation.to_go_to_step}} {{parseInt(stepIndex) + 1}}.
              <br>
              <br>
              {{message}}!
            </h3>

            <h3 v-if="parseInt(stepIndex) == 3 || parseInt(stepIndex) == 4" v-html="translation.how_increse_lead"></h3>
            <h3 v-if="parseInt(stepIndex) == 5" v-html="translation.how_increse_lead_5"></h3>
            <h3 v-if="parseInt(stepIndex) == 6" v-html="translation.how_increse_lead_6"></h3>
            <div
              v-if="!$parent.$parent.loading && (haveMinimumLeads || is_ambassador)"
              class="btn__next"
              v-on:click="nextStep()"
            >{{translation.pass}}</div>
            <div
              v-else
              class="btn__next disabled"
            >{{translation.pass}}</div>
            <div v-if="$parent.$parent.loading" class="loading"></div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <div class="card links">
          <div>
            <a
              :href="urls.fb_challenge"
              class="btn__link"
              target="_blank"
            >{{translation.access_facebook}}</a>
            <a :href="urls.read_more" class="btn__link" target="_blank">{{translation.read_more}}</a>
          </div>
          <div>
            <a
              :href="urls.rota_office_support"
              class="btn__link"
              target="_blank"
            >{{translation.support}}</a>
            <!-- <a :href="urls.rota_office_faqs" class="btn__link" target="_blank">{{translation.faq}}</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "info-steps",
  components: {},
  data() {
    return {
      stepIndex: 0,
      urls: this.$parent.$parent.view.generals_urls,
      translation: this.$parent.$parent.view.translation.infoSteps,
      is_ambassador: this.$parent.$parent.view.IS_AMBASSADOR_PLUS || this.$parent.$parent.view.IS_AMBASSADOR,
      haveMinimumLeads: true,
      message: ""
    };
  },
  methods: {
    nextStep() {
      this.$parent.nextStep();
      this.verifyRequisit();
    },
    previousStep() {
      this.$parent.previousStep();
      this.verifyRequisit();
    },
    verifyRequisit() {
      switch (parseInt(this.$parent.$parent.stepIndex)) {
          case 1:
            this.message = this.translation.step1_message_need_5_lead;
            break;
          case 2:
            this.message = this.translation.step2_message_need_25_lead;
            break;
          case 3:
            this.message = this.translation.step3_message_need_payment;
            break;
        }
      if (!this.$parent.haveMinimumLeads) {
        this.haveMinimumLeads = false;
      }
    }
  },
  mounted() {
    var me = this;
    setTimeout(function() {
      me.stepIndex = me.$parent.$parent.stepIndex;
      me.verifyRequisit();
    }, 500);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card {
  margin-top: 10px;

  h3 {
    width: 90%;
    margin: 0 auto;
  }
}
.next__step {
  display: flex;
  .next__step-arrow {
    background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNy4zMTcgMTUuNDYxIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjODE4YTkxOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0iaWNvbi1zZXRhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0yNy40MDgpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzY5NSIgZGF0YS1uYW1lPSJQYXRoIDY5NSIgY2xhc3M9ImNscy0xIiBkPSJNMTcuMTMzLDMyLjUzOWwtNC45NDgtNC45NDhhLjYxOS42MTksMCwwLDAtMS4wNTMuNDM1VjMwLjVIOC45NjhxLTYuODksMC04LjQ1NiwzLjg5NEE4LjgsOC44LDAsMCwwLDAsMzcuNjEzYTExLjYsMTEuNiwwLDAsMCwxLjIyNyw0LjM1OHEuMDI5LjA2OC4xLjIzMnQuMTMuMjlhMS4xLDEuMSwwLDAsMCwuMTI2LjIxMi4zMy4zMywwLDAsMCwuMjcxLjE2NC4yODIuMjgyLDAsMCwwLC4yMjctLjEuMzYuMzYsMCwwLDAsLjA4Mi0uMjQxLDEuOTY3LDEuOTY3LDAsMCwwLS4wMjQtLjI1NiwyLDIsMCwwLDEtLjAyNC0uMjI3cS0uMDQ4LS42NTctLjA0OC0xLjE4OGE4LjIyNSw4LjIyNSwwLDAsMSwuMTY5LTEuNzQ5LDUuMjUyLDUuMjUyLDAsMCwxLC40NjktMS4zMzgsMy4zNjIsMy4zNjIsMCwwLDEsLjc3My0uOTc2QTQuNTM2LDQuNTM2LDAsMCwxLDQuNSwzNi4xMjVhNS41MjcsNS41MjcsMCwwLDEsMS4yODUtLjQxMSwxMi4yNTQsMTIuMjU0LDAsMCwxLDEuNDg4LS4yMDhxLjc0OS0uMDU4LDEuNy0uMDU4aDIuMTY1djIuNDc0YS42MTUuNjE1LDAsMCwwLDEuMDUzLjQzNWw0Ljk0OC00Ljk0OGEuNjA3LjYwNywwLDAsMCwwLS44N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiLz4KICA8L2c+Cjwvc3ZnPg==);
    width: 28px;
    height: 25px;
    transition: 0.2s all;
    cursor: pointer;
    &:hover {
      transform: scale(1.2);
    }
  }
}
.links {
  display: flex;
  justify-content: space-between;
  padding: 2.3rem 2rem;
  .btn__link {
    display: block;
    background: #0294ff;
    color: white;
    padding: 0.6rem 1.4rem;
    font-weight: 700;
    border-radius: 4px;
    transition: 0.3s all;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;
    &:hover {
      background: #30a9ff;
    }
    &:first-child {
      margin-bottom: 1rem;
    }
  }
}

.container-fluid {
  padding-right: 0;
  padding-left: 0;
  margin-bottom: 0;
}

.infoSteps {
  margin-left: 25px;
  display: flex;

  .percent {
    width: 48%;
    margin-right: 25px;
  }
  .buttons {
    margin-right: 25px;
  }
  .card {
    margin-bottom: 0;
  }

  .btn__next {
    display: block;
    background: #0294ff;
    color: white;
    padding: 0.6rem 1.4rem;
    font-weight: 700;
    border-radius: 4px;
    transition: 0.3s all;
    text-align: center;
    margin-right: 12px;
    height: 38px;
    cursor: pointer;
    &:hover {
      background: #30a9ff;
    }
    &:first-child {
      margin-bottom: 1rem;
    }
    &.disabled {
      background: grey;
      cursor: no-drop;
     &:hover {
      background: grey;
    } 
    }
  }
}

.progress__bar {
  position: relative;
  margin: 2rem auto;
  width: 90%;
  .progress__check-final {
    position: absolute;
    left: 21px;
    top: 2px;
    color: #00fdc4;
    font-weight: 700;
  }
  .progress__container-in {
    display: flex;
    width: 100%;
    height: 20px;
    &:first-child {
      position: absolute;
      background: #e3e8eb;
      border-radius: 10px;
    }
  }

  .progress__container-in .progress__bar-in {
    transition: all 2s;
    height: 100%;
    background: #00fdc4;
    align-self: flex-end;
    position: relative;
    border-radius: 10px 0 0 10px;
    border-radius: 10px;
    &.all-rounded {
      border-radius: 10px;
    }
  }

  .progress__container-in .progress-premium {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ddd;
    border-left: 1px solid #828181;
    cursor: pointer;
  }
}
.loading {
  height: 30px;
  width: 30px;
  border-radius: 100%;
  border: 2px solid #0294ff;
  border-top-color: white;
  border-bottom-color: white;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 1300px) {
  .infoSteps {
    flex-direction: column;
    .percent {
      width: 100%;
      margin-right: 25px;
    }
  }
}
@media (max-width: 650px) {
  .links {
    flex-direction: column;
    a {
      margin-bottom: 1rem;
    }
  }
}
</style>
<style lang="scss">
.no__progress {
  h3,
  h2 {
    color: #676a6c;
    width: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/infoSteps.vue